import { Component, OnInit, Input } from '@angular/core';
import { isNull } from 'util';

@Component({
  selector: 'app-slider',
  templateUrl: './slider.component.html',
  styleUrls: ['./slider.component.scss']
})
export class SliderComponent implements OnInit {
  @Input() docs: any[];
  public data: any[];

  constructor() {
    this.data = [{ imagen: 'assets/images/default.png', descripcion: '' }]
    /* carosel.getCarousel({
      success: (resp) => {
        this.data = resp.data;
        if (isNull(this.data)) {
          this.data = ['assets/images/default.png'];
        }
      },
      error: (error) => {
        this.data = ['assets/images/default.png'];
        console.log("Error consultando las imagenes", error);
      }
    }) */
  }

  ngOnInit() {
  }

}





// WEBPACK FOOTER //
// ./src/app/shared/components/slider/slider.component.ts